import request from '@/utils/request'; // 获取车位列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/pakingLotOa/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/pakingLotOa/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/pakingLotOa/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/pakingLotOa/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/pakingLotOa/update',
    method: 'post',
    data: data
  });
} // 获取车位业主

export function fetchCustomerList(data) {
  return request({
    url: '/pmsservice/api/pakingLotOa/customerList',
    method: 'post',
    data: data
  });
} // 导出

export function exportList(data) {
  return request({
    url: '/pmsservice/api/pakingLotOa/exportList',
    method: 'post',
    data: data
  });
} // 导入模板

export function importBatch(data) {
  return request({
    url: '/pmsservice/api/pakingLotOa/importBatch',
    method: 'post',
    data: data
  });
}